import IElement, { VIElement } from '../IElement';

interface IFlag {
	type: 'append';
	element: IElement;
}
export default IFlag;

export const VIFlag = {
	type: { string: ['append'] },
	element: { object: VIElement },
};
